// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ReturnStatus = t.struct({
    description: t.String,
    id: t.String,
    parentId: t.String
}, {
    name: 'ReturnStatus',
    strict: true
});

export const getDefaultState = () => new ReturnStatus({
    description: '',
    id: '',
    parentId: ''
});

export default ReturnStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/return-status.js